import { parsedUserAgent } from "@100mslive/react-sdk";

export const defaultAudioList = [
  {
    name: "Audio1",
    id: "audio1",
    metadata: {
      description: "Artist1",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio1.mp3",
    type: "audio",
  },
  {
    name: "Audio2",
    id: "audio2",
    metadata: {
      description: "Artist2",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio2.mp3",
    type: "audio",
  },
  {
    name: "Audio3",
    id: "audio3",
    metadata: {
      description: "Artist3",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio3.mp3",
    type: "audio",
  },
  {
    name: "Audio4",
    id: "audio4",
    metadata: {
      description: "Artist4",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio4.mp3",
    type: "audio",
  },
  {
    name: "Audio5",
    id: "audio5",
    metadata: {
      description: "Artist5",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio5.mp3",
    type: "audio",
  },
  {
    name: "Audio6",
    id: "audio6",
    metadata: {
      description: "Artist6",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/audio6.mp3",
    type: "audio",
  },
];

export const defaultVideoList = [
  {
    name: "Video1",
    id: "video1",
    metadata: {
      description: "Artist1",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video1.mp4",
    type: "video",
  },
  {
    name: "Video2",
    id: "video2",
    metadata: {
      description: "Artist2",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video2.mp4",
    type: "video",
  },
  {
    name: "Video3",
    id: "video3",
    metadata: {
      description: "Artist2",
    },
    url: "https://bc-public-static-assets.s3.ap-south-1.amazonaws.com/webapp/playlist/video3.mp4",
    type: "video",
  },
];

export const DEFAULT_HLS_ROLE_KEY = "HLS_VIEWER_ROLE";
export const DEFAULT_HLS_VIEWER_ROLE = "hls-viewer";
export const DEFAULT_WAITING_VIEWER_ROLE = "waiting-room";
export const QUERY_PARAM_SKIP_PREVIEW = "skip_preview";
export const QUERY_PARAM_SKIP_PREVIEW_HEADFUL = "skip_preview_headful";
export const QUERY_PARAM_NAME = "name";
export const QUERY_PARAM_VIEW_MODE = "ui_mode";
export const QUERY_PARAM_AUTH_TOKEN = "auth_token";
export const QUERY_PARAM_PREVIEW_AS_ROLE = "preview_as_role";
export const UI_MODE_ACTIVE_SPEAKER = "activespeaker";
export const UI_MODE_GRID = "grid";
export const MAX_TOASTS = 5;
export const RTMP_RECORD_RESOLUTION_MIN = 480;
export const RTMP_RECORD_RESOLUTION_MAX = 1280;
export const RTMP_RECORD_DEFAULT_RESOLUTION = {
  width: 1280,
  height: 720,
};

export const CHAT_SELECTOR = {
  PEER_ID: "peer_id",
  ROLE: "role",
};

export const APP_DATA = {
  uiSettings: "uiSettings",
  chatOpen: "chatOpen",
  chatSelector: "chatSelector",
  chatDraft: "chatDraft",
  appConfig: "appConfig",
  recordingUrl: "recordingUrl",
  sidePane: "sidePane",
  hlsStats: "hlsStats",
  hlsViewerRole: "hlsViewerRole",
  waitingViewerRole: "waitingViewerRole",
  subscribedNotifications: "subscribedNotifications",
  logo: "logo",
  tokenEndpoint: "tokenEndpoint",
  appLayout: "appLayout",
  hlsStarted: "hlsStarted",
  rtmpStarted: "rtmpStarted",
  recordingStarted: "recordingStarted",
  embedConfig: "embedConfig",
  pinnedTrackId: "pinnedTrackId",
};
export const UI_SETTINGS = {
  isAudioOnly: "isAudioOnly",
  isHeadless: "isHeadless",
  maxTileCount: "maxTileCount",
  uiViewMode: "uiViewMode",
  showStatsOnTiles: "showStatsOnTiles",
  enableAmbientMusic: "enableAmbientMusic",
  mirrorLocalVideo: "mirrorLocalVideo",
};

export const SIDE_PANE_OPTIONS = {
  PARTICIPANTS: "Participants",
  CHAT: "Chat",
  STREAMING: "STREAMING",
  TILES: "TILES",
  SCREEN_TILES: "SCREEN_TILES",
};

export const SUBSCRIBED_NOTIFICATIONS = {
  PEER_JOINED: "PEER_JOINED",
  PEER_LEFT: "PEER_LEFT",
  METADATA_UPDATED: "METADATA_UPDATED",
  NEW_MESSAGE: "NEW_MESSAGE",
  // ERROR: "ERROR",
};

export const CREATE_ROOM_DOC_URL =
  "https://github.com/100mslive/100ms-web/wiki/Creating-and-joining-a-room";

export const REMOTE_STOP_SCREENSHARE_TYPE = "REMOTE_STOP_SCREENSHARE";

export const isIOS = parsedUserAgent.getOS()?.name?.toLowerCase() === "ios";
export const isMacOS =
  parsedUserAgent.getOS()?.name?.toLowerCase() === "mac os";
export const isAndroid =
  parsedUserAgent.getOS()?.name?.toLowerCase() === "android";

// examTabs.ts
// roleTabs.ts
export const roleHeadingsData = [
  {
    id: 1,
    label: "Business Analytics",
    content: {
      headline:
        "Test your problem-solving skills as a future Business Analyst with CEE.",
      subText:
        "Demonstrate your ability to analyze data and solve real-world business problems with confidence.",
    },
  },
  {
    id: 2,
    label: "Data Scientist",
    content: {
      headline:
        "Show your ML & data understanding — prove your Data Science edge with CEE.",
      subText:
        "Demonstrate your expertise in machine learning and data-driven decision-making.",
    },
  },
  {
    id: 3,
    label: "Data Visualisation",
    content: {
      headline:
        "Are your dashboards impactful? Validate your visualization skills via CEE.",
      subText:
        "Showcase your ability to design clear, insightful, and impactful dashboards.",
    },
  },
  {
    id: 4,
    label: "Finance Analytics",
    content: {
      headline: "Test your ability to decode financial data — check with CEE.",
      subText:
        "Demonstrate your strength in analyzing financial data and deriving actionable insights.",
    },
  },
  {
    id: 5,
    label: "Marketing Analytics",
    content: {
      headline: "See if your Marketing insights stand out — test with CEE.",
      subText:
        "Prove your capability to turn marketing data into winning strategies.",
    },
  },
  {
    id: 6,
    label: "Operations Analytics",
    content: {
      headline:
        "Measure your decision-making power in Ops Analytics — CEE shows your level.",
      subText:
        "Demonstrate your operational problem-solving and decision-making abilities.",
    },
  },
  {
    id: 7,
    label: "Business Consulting",
    content: {
      headline:
        "Consultants solve ambiguity — see your consulting readiness with CEE.",
      subText:
        "Show your strength in structured thinking, problem-solving, and client-readiness.",
    },
  },
  {
    id: 8,
    label: "Strategy",
    content: {
      headline:
        "Do you think like a strategist? Prove it to recruiters with a CEE.",
      subText:
        "Demonstrate your ability to craft long-term business strategies.",
    },
  },
  {
    id: 9,
    label: "Accounting and Audit",
    content: {
      headline:
        "Show your accuracy & rigor — validate accounting/audit strength with CEE.",
      subText:
        "Demonstrate your eye for detail and ability to ensure compliance.",
    },
  },
  {
    id: 10,
    label: "Business Finance",
    content: {
      headline: "Test your financial decision-making instincts with CEE.",
      subText: "Showcase your ability to manage business finances effectively.",
    },
  },
  {
    id: 11,
    label: "Corporate Banking",
    content: {
      headline: "See if you’re deal-ready for banking with CEE.",
      subText:
        "Prove your readiness for client-facing banking and transactions.",
    },
  },
  {
    id: 12,
    label: "Corporate Finance",
    content: {
      headline:
        "Validate your capital structuring & valuation skills — CEE shows your fit.",
      subText:
        "Demonstrate your expertise in valuation, capital structuring, and financial modeling.",
    },
  },
  {
    id: 13,
    label: "Equity Research",
    content: {
      headline: "Do your insights match the market? Test with CEE.",
      subText:
        "Showcase your ability to analyze companies and generate market insights.",
    },
  },
  {
    id: 14,
    label: "Investment Banking",
    content: {
      headline:
        "Test your speed & precision under pressure — IB readiness via CEE.",
      subText:
        "Prove your analytical rigor and ability to perform under high-pressure environments.",
    },
  },
  {
    id: 15,
    label: "FInOps",
    content: {
      headline:
        "Prove your ability in finance + ops — check readiness with CEE.",
      subText:
        "Demonstrate your capability to align financial and operational strategies.",
    },
  },
  {
    id: 16,
    label: "Risk Management",
    content: {
      headline: "Spot risks like a pro — see your risk instincts with CEE.",
      subText:
        "Showcase your ability to identify, assess, and mitigate business risks.",
    },
  },
  {
    id: 17,
    label: "Compensation and Benefits",
    content: {
      headline:
        "Test your ability to design fair & competitive rewards via CEE.",
      subText:
        "Demonstrate your expertise in structuring effective pay & benefits programs.",
    },
  },
  {
    id: 18,
    label: "Employee Engagement",
    content: {
      headline:
        "Measure how well you can boost culture and engagement with CEE.",
      subText:
        "Showcase your ability to foster motivation and organizational culture.",
    },
  },
  {
    id: 19,
    label: "HR Generalist",
    content: {
      headline:
        "Generalists need balance — check your HR versatility with CEE.",
      subText:
        "Demonstrate your capability to manage multiple HR functions seamlessly.",
    },
  },
  {
    id: 20,
    label: "HR Strategy",
    content: {
      headline:
        "Test your ability to align people and business strategy with CEE.",
      subText:
        "Showcase your expertise in connecting workforce planning with business goals.",
    },
  },
  {
    id: 21,
    label: "Learning and Development",
    content: {
      headline: "Can you build future leaders? Test L&D readiness with CEE.",
      subText:
        "Demonstrate your ability to design and implement impactful training programs.",
    },
  },
  {
    id: 22,
    label: "Performance Management",
    content: {
      headline:
        "Evaluate your skills in driving performance & productivity with CEE.",
      subText:
        "Showcase your ability to measure, improve, and sustain employee performance.",
    },
  },
  {
    id: 23,
    label: "Talent Acquisition",
    content: {
      headline: "Do you hire right? Test your recruiter instincts with CEE.",
      subText:
        "Demonstrate your expertise in identifying and selecting top talent.",
    },
  },
  {
    id: 24,
    label: "Operations Consulting",
    content: {
      headline:
        "Test your HR ops problem-solving — consulting readiness via CEE.",
      subText:
        "Showcase your consulting skills in solving HR and operational challenges.",
    },
  },
  {
    id: 25,
    label: "Service Operations",
    content: {
      headline: "Measure your ability to deliver customer excellence with CEE.",
      subText:
        "Demonstrate your ability to enhance service quality and efficiency.",
    },
  },
  {
    id: 26,
    label: "Supply Chain Management",
    content: {
      headline: "Check your end-to-end SCM problem-solving power with CEE.",
      subText:
        "Showcase your ability to optimize supply chains and ensure smooth operations.",
    },
  },
  {
    id: 27,
    label: "B2B Sales and Marketing",
    content: {
      headline:
        "Test your ability to win businesses — test B2B skills with CEE.",
      subText:
        "Demonstrate your expertise in building client relationships and driving B2B growth.",
    },
  },
  {
    id: 28,
    label: "B2C Sales and Marketing",
    content: {
      headline: "Are you consumer-savvy? CEE shows your B2C readiness.",
      subText:
        "Showcase your ability to understand and influence consumer behavior.",
    },
  },
  {
    id: 29,
    label: "Category Management Ecommerce",
    content: {
      headline: "Can you own an e-category? Validate with CEE.",
      subText:
        "Demonstrate your ability to manage, optimize, and grow product categories.",
    },
  },
  {
    id: 30,
    label: "Digital Marketing",
    content: {
      headline: "Prove your SEO, SEM & content edge — test via CEE.",
      subText:
        "Showcase your expertise in digital channels, campaigns, and performance tracking.",
    },
  },
  {
    id: 31,
    label: "FMCG(D)",
    content: {
      headline:
        "Fast-paced FMCG needs agility — check your FMCG instincts with CEE.",
      subText:
        "Demonstrate your adaptability and execution skills in FMCG environments.",
    },
  },
  {
    id: 32,
    label: "General Management",
    content: {
      headline:
        "Future leaders prove their range — test your GM readiness with CEE.",
      subText:
        "Showcase your ability to handle multi-functional leadership challenges.",
    },
  },
  {
    id: 33,
    label: "Market Research",
    content: {
      headline: "Test your ability to turn insights into impact with CEE.",
      subText:
        "Demonstrate your ability to design, analyze, and present market studies.",
    },
  },
  {
    id: 34,
    label: "Product Management",
    content: {
      headline: "Can you think like a PM? Validate your skills with CEE.",
      subText:
        "Showcase your expertise in product strategy, design, and execution.",
    },
  },
  {
    id: 35,
    label: "Consumer Banking",
    content: {
      headline: "See if your consumer insights match banking needs with CEE.",
      subText:
        "Demonstrate your ability to design consumer-focused banking solutions.",
    },
  },
  {
    id: 36,
    label: "IT Business Analyst",
    content: {
      headline: "Bridge tech & business like a true BA — validate with CEE.",
      subText:
        "Showcase your ability to translate business needs into technical requirements.",
    },
  },
  {
    id: 37,
    label: "IT PreSales",
    content: {
      headline: "Test your ability to pitch & win deals with CEE.",
      subText:
        "Demonstrate your strength in solution design, proposals, and client pitching.",
    },
  },
  {
    id: 38,
    label: "IT Program Management",
    content: {
      headline: "Large programs need discipline — prove PMO strength with CEE.",
      subText:
        "Showcase your expertise in driving large-scale program delivery.",
    },
  },
  {
    id: 39,
    label: "IT Project Management",
    content: {
      headline:
        "Deliver projects with precision — validate your PM skills via CEE.",
      subText:
        "Demonstrate your ability to plan, manage, and deliver projects effectively.",
    },
  },
  {
    id: 40,
    label: "Tech B2B Sales",
    content: {
      headline: "Test your ability to sell tech in B2B with CEE.",
      subText:
        "Showcase your expertise in driving technology-led business growth.",
    },
  },
  {
    id: 41,
    label: "Tech Consulting",
    content: {
      headline:
        "Are you client-ready? Test your tech consulting edge with CEE.",
      subText:
        "Demonstrate your ability to solve client problems with tech-driven solutions.",
    },
  },
  {
    id: 42,
    label: "Tech Product Management",
    content: {
      headline:
        "Think product + tech together — see your PM readiness with CEE.",
      subText:
        "Showcase your expertise in managing technology-driven product lifecycles.",
    },
  },
];
